// src/Theme/themePrimitives.js
import React from 'react';
export const ColorModeContext = React.createContext({ mode: 'light', toggleColorMode: () => {} });
